package com.vamvisions.main.portfolio.domain.repository

import com.vamvisions.main.core.domain.DataError
import com.vamvisions.main.core.domain.Result
import com.vamvisions.main.core.domain.preferences.Language
import com.vamvisions.main.portfolio.domain.model.Project

interface ProjectRepository {
    /** The published projects, with their texts in [language], in the order the server returns them. */
    suspend fun get(language: Language): Result<List<Project>, DataError.Network>
}
